"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavTelemetryEventEmitter = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const react_router_1 = require("react-router");
function locationHasChanged(prevLocation, newLocation) {
    return prevLocation.pathname !== newLocation.pathname || prevLocation.search !== newLocation.search;
}
function locationToString(location) {
    return `${location.pathname}${location.search}`;
}
class NavTelemetryEventEmitterInternal extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.prevLocation = this.props.history.location;
        this.unlisten = () => undefined;
    }
    componentDidMount() {
        this.unlisten = this.props.history.listen((location) => {
            if (locationHasChanged(this.prevLocation, location)) {
                this.props.uiActions.sendNavigationTelemetryEvent(locationToString(this.prevLocation), locationToString(location));
            }
            this.prevLocation = location;
        });
    }
    componentWillUnmount() {
        this.unlisten();
    }
    render() {
        return null;
    }
}
exports.NavTelemetryEventEmitter = (0, react_router_1.withRouter)(NavTelemetryEventEmitterInternal);
//# sourceMappingURL=NavTelemetryEventEmitter.js.map